<div id="{{Id}}">
  <div class="row">
    <div class="col-sm-8">
      <ap-macro-editor-details #details
                               [baseId]="Id"
                               [macroService]="macroService"
                               [macroDefinitionDto]="macroDefinitionDto"
                               [defaultMacroGroup]="defaultMacroGroup">
      </ap-macro-editor-details>
    </div>
    <div class="col-sm-4">
      <div class="fnd-text-editor-macro-nav">
        <div class="row">
          <div class="col-sm-12 macro-hints">
            <ap-text-editor-macro-selector [baseId]="Id"
                                           [modifyAlwaysHidden]="true"
                                           [newHidden]="true"
                                           [insertHidden]="true"
                                           [macroService]="macroService"
                                           [macroInterfaces]="macroInterfaces">
            </ap-text-editor-macro-selector>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="loading">
  <div class="text-center">
    <ap-spinner size="3"></ap-spinner>
  </div>
</div>
